import { render } from "./SelectCards.vue?vue&type=template&id=7b873a2a&scoped=true"
import script from "./SelectCards.vue?vue&type=script&lang=js"
export * from "./SelectCards.vue?vue&type=script&lang=js"

import "./SelectCards.vue?vue&type=style&index=0&id=7b873a2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b873a2a"]])

export default __exports__